import React, { useEffect } from 'react';
import '../../assets/vendor/css/pages/page-auth.css'
import { useNavigate } from 'react-router-dom';

import { removeUserSession } from '../../helpers/Helper';


const Login = (props) => {
    const navigate = useNavigate();
    useEffect(() => {
        removeUserSession()
        navigate("/");
    }, [navigate])

    return (
        <>
            <div>
            </div>
        </>
    );
}
export default Login;